import { CodigoDTO } from "../interfaces/codigo.interface";
import { CodigoServicioDTO } from "../interfaces/grupo-servicio.interface";
import { HorarioDTO } from "../interfaces/horarios.interface";
import { TipoCuenta } from "../interfaces/tipo-cuenta.interface";

export class ContratistaDTO {
    constructor(
        public nrRut: number,
        public dv: string,
        public nombres: string,
        public apellidos: string,
        public idBanco: number,
        public idTipoCuenta: number,
        public numeroCuenta: string,
        public email:string,
        public banco?: CodigoDTO,
        public rut?: string,
        public tipoCuenta?: TipoCuenta,
        public evaluacion?: number,
        public gruposServicio?: CodigoServicioDTO[],
        public comunas?: CodigoDTO[],
        public fechaTermino?: string,
        public activo?: boolean,
        public codigoFoto?: string,
        public horario?: HorarioDTO
        
    ) {
        this.nrRut = nrRut;
        this.dv = dv;
        this.nombres = nombres;
        this.apellidos = apellidos;
        this.idBanco = idBanco;
        this.idTipoCuenta = idTipoCuenta;
        this.numeroCuenta = numeroCuenta;
        this.banco = banco || null;
        this.rut = rut || null;
        this.tipoCuenta = tipoCuenta || null;
        this.evaluacion = evaluacion || null;
        this.gruposServicio = gruposServicio || null;
        this.comunas = comunas || null;
        this.fechaTermino = fechaTermino || null;
        this.activo = activo || null;
        this.email=email;
        this.codigoFoto = codigoFoto || null;
        this.horario = horario || null;
    }
}
